// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-content {
	padding: 24px !important;
}

.dashboard-content .link {
	padding-top: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/index.css"],"names":[],"mappings":"AAAA;CACC,wBAAwB;AACzB;;AAEA;CACC,gBAAgB;AACjB","sourcesContent":[".dashboard-content {\n\tpadding: 24px !important;\n}\n\n.dashboard-content .link {\n\tpadding-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
